import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ReservationPage = () => {
  const navigate = useNavigate();
  const { user, logout, isAuthenticated } = useAuth();

  const [count, setCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [stats, setStats] = useState(null);
  const [hasReservation, setHasReservation] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    fetchStats();
  }, [isAuthenticated, navigate]);

  const fetchStats = async () => {
    try {
      const res = await axios.get(`${API}/event/stats`);
      setStats(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleReservation = async () => {
    setError('');
    setLoading(true);

    if (count <= 0) {
      setError('Kişi sayısı 1 veya daha fazla olmalı');
      setLoading(false);
      return;
    }

    try {
      await axios.post(`${API}/reservations`, { count });
      setSuccess(true);
      setHasReservation(true);
      fetchStats();
    } catch (err) {
      if (err.response?.status === 401) {
        logout();
        navigate('/login');
        return;
      }

      const msg =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        'Rezervasyon oluşturulamadı';

      if (msg.includes('aktif bir rezervasyon')) {
        setHasReservation(true);
      }

      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthenticated) return null;

  return (
    <div className="container">
      <div style={{ maxWidth: '600px', margin: '0 auto', paddingTop: '40px' }}>

        {/* HEADER */}
        <div className="flex justify-between items-center mb-10">
          <div>
            <h2 className="text-red-500 text-2xl font-extrabold">
              Hoş geldin, {user?.name}
            </h2>
            <p className="text-white/60">📱 {user?.phone}</p>
          </div>
          <button
            className="btn btn-secondary"
            onClick={() => {
              logout();
              navigate('/');
            }}
          >
            Çıkış
          </button>
        </div>

        {/* EVENT */}
        <div className="card neon-border text-center mb-8">
          <h1 className="hero-title mb-2">SÖMESTR PARTY</h1>
          <p className="text-white/70 font-semibold">PWR ORGANİZASYON</p>

          {stats && (
            <div className="mt-8 pt-6 border-t border-red-900/40">
              <p className="text-white/70 uppercase tracking-wide">
                🎟️ Kalan Bilet
              </p>
              <p className="text-red-500 text-6xl font-black mt-2">
                {stats.remaining_tickets}
              </p>
            </div>
          )}
        </div>

        {/* MESSAGES */}
        {error && <div className="error-message">{error}</div>}
        {success && (
          <div className="success-message">
            ✓ Rezervasyonunuzu aldık. En kısa sürede sizinle iletişime geçeceğiz..
          </div>
        )}

        {/* RESERVATION */}
        <div className="card">
          <h3 className="text-red-500 text-xl font-extrabold text-center mb-6">
            🎟️ Kaç Kişi Geleceksiniz?
          </h3>

          <div style={{ marginBottom: '28px' }}>
            <input
              type="number"
              min="1"
              className="input-field text-center text-xl font-bold"
              value={count}
              onChange={(e) => setCount(Number(e.target.value))}
            />
          </div>

          <button
            className="btn btn-primary w-full text-lg py-4 font-bold"
            onClick={handleReservation}
            disabled={loading || success || hasReservation}
          >
            {loading
              ? 'İşleniyor...'
              : hasReservation
              ? '✓ Zaten Rezervasyonunuz Var'
              : `🎟️ ${count} Kişi İçin Rezervasyon Yap`}
          </button>

          <p className="text-white/50 text-center mt-4 text-sm">
            * Rezervasyonunuz oluşturulduktan sonra detaylar için sizinle iletişime geçilecektir.
          </p>
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-secondary" onClick={() => navigate('/')}>
            ← Ana Sayfaya Dön
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReservationPage;
